import { FC } from "react";
import { Outlet } from "react-router-dom";
import { ChatHighlightsProvider } from "../../providers/ChatHighlights/ChatHighlightsProvider";

interface Props {
  element?: any;
  path?: string;
}

export const ChatHighlightsRoute: FC<Props> = () => {
  return (
    <ChatHighlightsProvider>
      <Outlet />
    </ChatHighlightsProvider>
  );
};
